import { HIGHEST_LOWEST_ROLLOVER, HIGHEST_LOWEST_ROLLOVER_STREAM, ROLLOVER_LAST_UPDATED_TIME, } from "../../../interface/DrivingMarket/iHighLowRollovers";
import { drivingMarketStream } from "@domains/features/Markets/Futures/utils/streamingUpdate";
let initState = {
    highLowRolloverData: [],
    latestUpdatedTime: "",
};
const highestLowestRollovers = (state = initState, action) => {
    var _a;
    switch (action.type) {
        case HIGHEST_LOWEST_ROLLOVER:
            return Object.assign(Object.assign({}, state), { highLowRolloverData: action.payload.highLowRolloverData });
        case HIGHEST_LOWEST_ROLLOVER_STREAM:
            return Object.assign(Object.assign({}, state), { highLowRolloverData: drivingMarketStream(state.highLowRolloverData, action.payload.qouteStream), latestUpdatedTime: (_a = action.payload.qouteStream) === null || _a === void 0 ? void 0 : _a.updatedTime });
        case ROLLOVER_LAST_UPDATED_TIME:
            return Object.assign(Object.assign({}, state), { latestUpdatedTime: action.payload.latestUpdatedTime });
        default:
            return state;
    }
};
export default highestLowestRollovers;
